<form class="credit-invoice-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INVOICE.CREDIT_INVOICE_HEADER' | translate }} {{ dataContext.invoiceNumber }}</h4>

  <section class="astral-section-surface astral-section-surface--compact astral-form-stack">
    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
      <app-text-box-readonly
        [caption]="'INVOICE.INVOICEAMOUNT'"
        [text]="dataContext.amount.amount | money: false : null : dataContext.amount.currencyCode"
      ></app-text-box-readonly>
      <app-text-box-readonly
        [caption]="'INVOICE.REMAINING_AMOUNT'"
        [text]="dataContext.remainingAmount.amount | money: false : null : dataContext.remainingAmount.currencyCode"
      ></app-text-box-readonly>
      <div class="astral-form-adjacent-action">
        <astral-checkbox [control]="form.controls['creditRows']"></astral-checkbox>
      </div>
    </astral-layout-group>

    @if (!creditRows) {
      <app-money-box
        [control]="form.controls['amount']"
        [helpText]="'INVOICE.HELP_TEXT.CREDIT_AMOUNT'"
      ></app-money-box>
    }
  </section>

  @if (creditRows) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
      @for (rowForm of rowForms; track rowForm) {
        @if (rowForm.controls['id'].value) {
          <article class="astral-section-surface astral-section-surface--subtle astral-stack-m">
            <h5>{{ rowForm.controls['description'].value }}</h5>
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <app-money-box [control]="rowForm.controls['invoicedAmount']"></app-money-box>
              <app-money-box [control]="rowForm.controls['vatAmount']"></app-money-box>
              <app-money-box [control]="rowForm.controls['creditedAmount']"></app-money-box>
            </astral-layout-group>
            <astral-layout-group [columns]="6" [tabletColumns]="3" [mobileColumns]="1">
              <app-money-box [control]="rowForm.controls['paidAmount']"></app-money-box>
              <app-money-box [control]="rowForm.controls['balance']"></app-money-box>
              <app-money-box [control]="rowForm.controls['correction']"></app-money-box>
              <app-money-box [control]="rowForm.controls['newBalance']"></app-money-box>
              <div class="astral-form-adjacent-action astral-grid-span-2">
                <astral-button
                  size="small"
                  variant="secondary"
                  type="button"
                  labelKey="INVOICE.CREDIT_ROWS.CREDIT_MAX"
                  (click)="creditMax(rowForm.controls['id'].value)"
                ></astral-button>
              </div>
            </astral-layout-group>
          </article>
        }
        @if (!rowForm.controls['id'].value) {
          <article class="astral-section-surface astral-section-surface--subtle astral-stack-m">
            <h5>{{ rowForm.controls['description'].value }}</h5>
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <app-money-box [control]="rowForm.controls['balance']"></app-money-box>
              <app-money-box [control]="rowForm.controls['correction']"></app-money-box>
              <app-money-box [control]="rowForm.controls['newBalance']"></app-money-box>
            </astral-layout-group>
          </article>
        }
      }
      <article class="astral-section-surface astral-section-surface--subtle astral-stack-m">
        <h5>{{ 'COMMON.SUM' | translate }}</h5>
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <app-money-box [control]="sumForm.controls['balance']"></app-money-box>
          <app-money-box [control]="sumForm.controls['correction']"></app-money-box>
          <app-money-box [control]="sumForm.controls['newBalance']"></app-money-box>
        </astral-layout-group>
      </article>
      @if (errorMessage) {
        <span class="error">{{ errorMessage }}</span>
      }
    </section>
  }

  @if (customerBalance) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        <app-text-box-readonly
          [caption]="'INVOICE.CREDIT_INVOICE_CUSTOMER_BALANCE'"
          [text]="customerBalance.amount | money: false : null : customerBalance.currencyCode"
          [helpText]="'INVOICE.HELP_TEXT.CREDIT_CREATE_CUSTOMER_BALANCE'"
        ></app-text-box-readonly>
        <astral-select
          class="astral-grid-span-2"
          [itemsSource]="leaseAgreements"
          [control]="form.controls['leaseAgreementId']"
          [helpText]="'INVOICE.HELP_TEXT.CREDIT_LINK_CUSTOMER_BALANCE_TO_LEASE'"
        ></astral-select>
      </astral-layout-group>
    </section>
  }

  <section class="astral-section-surface astral-section-surface--compact">
    <astral-input
      [control]="form.controls['verificationDescription']"
      [helpText]="'INVOICE.HELP_TEXT.CREDIT_ACCOUNTING_DESCRIPTION'"
    ></astral-input>
  </section>

  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" [disabled]="form.disabled" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" [disabled]="form.disabled" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
